export default __webpack_public_path__ + "static/alloy-8d14c3f656d4d9d11abaddedfe3833b5.png";